import { c as _c } from "react/compiler-runtime";
import style from "./GiveWellStamp.module.scss";
import Stamp from "./Stamp.png";
import GiveWellLogo from "./GiveWellLogo.png";
import Image from "next/image";
import { LinkType, Links } from "../Links/Links";
export type GiveWellStampProps = {
  links: LinkType[];
  quote: string;
  quotee: string;
  quoteePosition: string;
};
export const GiveWellStamp: React.FC<GiveWellStampProps> = t0 => {
  const $ = _c(21);
  const {
    links,
    quote,
    quotee,
    quoteePosition
  } = t0;
  let t1;
  if ($[0] !== links) {
    t1 = <Links links={links} />;
    $[0] = links;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={style.stamp}><Image src={Stamp} alt="" style={{
        objectFit: "contain"
      }} fill={true} sizes="20vw, 400w" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={style.context}>{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={style.logo}><Image src={GiveWellLogo} alt="GiveWell" style={{
        objectFit: "contain"
      }} fill={true} sizes="20vw, 400w" /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== quote) {
    t5 = <blockquote><p className="inngress">“{quote}”</p></blockquote>;
    $[6] = quote;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== quotee) {
    t6 = <span className={style.quoteAuthor}>{quotee}</span>;
    $[8] = quotee;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== quoteePosition) {
    t7 = <span className={style.quotePosition}>{quoteePosition}</span>;
    $[10] = quoteePosition;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <figcaption><cite>{t6}{t7}</cite></figcaption>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t8) {
    t9 = <div className={style.quote}><div className={style.quoteText}>{t4}<figure>{t5}{t8}</figure></div></div>;
    $[15] = t5;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t9) {
    t10 = <div className={style.container}>{t3}{t9}</div>;
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};